export enum CustomerSettingsKey {
  VolumeUnit = "measurementunit.volume",
  Timezone = "culture.timezone",
  TileVisibility = "tileVisibility"
}

export interface GetCustomerSettingsResponse {
  key: string;
  value: string;
}

export interface SetCustomerSettingsResponse {
  key: string;
  value: string;
}
